import { createSelector } from 'reselect';
import { ApplicationRootState } from 'types';
import { initialState } from './reducer';

const selectKamereoEssentialDomain = (state: ApplicationRootState) => state.kamereoEssentialPage || initialState;

const selectKamereoEssentialPage = () => createSelector(selectKamereoEssentialDomain, (substate) => substate);

const selectLoading = () => createSelector(selectKamereoEssentialDomain, (substate) => substate.loading);
const selectSections = () => createSelector(selectKamereoEssentialDomain, (substate) => substate.sections);
const selectNoteItemLoading = () => createSelector(selectKamereoEssentialDomain, (substate) => substate.loadingNote);

export default selectKamereoEssentialPage;
export { selectKamereoEssentialDomain, selectLoading, selectSections, selectNoteItemLoading };
